<template>
	<div id="reservation">
	    <div class="page-container" id="reservation-container">
	        <div class="page-content" id="reservation-content">
				<header id="main-menu" class="logo-header">
				    <div class="store-info menu-content">
				        <div class="logo-col">
				            <img :src="storeLogo">
				        </div>
				        <div class="store-name">
				            <h1>{{storeName}}</h1>
				        </div>
				    </div>
				</header>
			    <nav id="main-nav" class="detail-nav">
			        <div class="reservation-tips-grid" v-if="cancelConfirmed !== true">
			            <div class="tip-grid-col">
			                <span class="icon-users"></span>
			                <span id="grid-number-col">{{ currentSize }}</span>
			            </div>
			            <div class="tip-grid-col">
			                <span class="icon-calendar-alt-fill"></span>
			                <span id="grid-date-col">{{ currentDate }}</span>
			            </div>
			            <div class="tip-grid-col">
			                <span class="icon-clock2"></span>
			                <span id="grid-time-col" data-sort="" data-tab="0" data-time-tab="0">{{ currentTime }}</span>
			            </div>
			        </div>
			    </nav>
	            <!--<div id="main-title">
	                <h2>Your Reservation</h2>
	            </div>-->
	            <article class="swiper-container" id="swiper-container" v-show="!loadingShow">
	                <div class="swiper-wrapper">
	                    <section id="page-1" class="swiper-slide swiper-no-swiping" v-show="currentPage === 0">
		                    	<div v-if="cancelConfirmed !== true">
		                    		<div v-if="showCancelAlert !== true">
			                        <div id="orderSuccessful-mod" class="orderDetial-mod" v-if="isHidden === true">
			                            <ul class="order-details">
			                                <li class="storeName-col">
			                                    Your reservation at
			                                    <strong id="orderSuccessfulName">{{ storeName }}</strong>
			                                </li>
			                            </ul>
		                                <ul class="order-details">
		                                    <li class="name-col">
		                                        Customer:
		                                        <strong id="orderName">
		                                            <span id="orderFirstName">{{ infoForm.firstName }}</span>&nbsp;<span id="orderLastName">{{ infoForm.surname }}</span>
		                                        </strong>
		                                    </li>
		                                </ul>
		                                <ul class="order-details">
		                                    <li class="date-col">
		                                        Date:
		                                        <strong id="orderDate">{{ currentDate }}</strong>
		                                    </li>
		                                    <li class="week-col">
		                                        On:
		                                        <strong id="orderWeek">{{ week }}</strong>
		                                    </li>
		                                    <li class="time-col">
		                                        Time:
		                                        <strong id="orderTime">{{ currentTime }}</strong>
		                                    </li>
		                                </ul>
		                                <ul class="order-details">
		                                    <li class="people-col">
		                                        People:
		                                        <strong id="orderPeople">{{ currentSize }} px</strong>
		                                    </li>
		                                    <li class="phone-col">
		                                        Phone:
		                                        <strong id="orderPhone">
		                                        	<span v-show="infoForm.areaCode !== '' || infoForm.areaCode !== ' '">{{ infoForm.areaCode }} </span>
		                                        	{{ infoForm.phone }}
		                                        </strong>
		                                    </li>
		                                </ul>
		                                <ul class="order-details">
		                                    <li class="email-col">
		                                        Email:
		                                        <strong id="orderEmail">{{ infoForm.email }}</strong>
		                                    </li>
		                                </ul>



			                        </div>
			                        <div id="confirmedTips" class="orderDetial-mod" v-if="isHidden !== true">
		                                <ul class="order-details">
			                                <li>
			                                    Thank you for your reservation.
			                                    <strong>Your booking has been confirmed.</strong>
			                                </li>
		                                </ul>
			                        </div>
		                        </div>
		                        <div id="cancelAlert" class="cancelStyleTips" v-if="showCancelAlert === true">
			                        	<div class="alertBody">
		                                <div class="titleCol">Cancel your reservation?</div>
		                                <p>Are you sure you wish to cancel your booking with {{ storeName }} on {{ week }}, {{ currentDate }} at {{ currentTime }} for {{ currentSize}} people?</p>
	                                </div>
		                        </div>
		                    	</div>
	                        <div id="cancelConfirmedTips" class="cancelStyleTips" v-if="cancelConfirmed === true">
		                        	<div class="alertBody">
	                                <div class="titleCol">Your booking has been cancelled</div>
	                                <p>We're sorry you couldn't make it.</p>

                                </div>
	                        </div>

	                        <div class="buttons-col">
								<button @click="confirmReserve(res_id)" id="confirmReserveBtn"    class="btn confirmStyle" v-if="isHidden === true && showCancelAlert !== true" type="button">
									<span class="ladda-label">Confirm Reservation</span>
								</button>
								<button @click="showCancelAlert = true" id="cancelReserveBtn" class="btn cancelStyle" type="button" v-if="isHidden === true && showCancelAlert !== true">
									<span class="ladda-label">Cancel Reservation</span>
								</button>

								<button @click="cancelConfirm(res_id)" id="confirmCancelReserveBtn" class="btn cancelStyle" type="button" v-if="showCancelAlert === true && cancelConfirmed !== true">
									<span class="ladda-label">Confirm Cancellation</span>
								</button>
	                        </div>
	                        <!-- <div class="links-line">
	                            <div class="link-grid">
	                                <a href="https://www.streetaway.co.uk" id="sparkWebSiteLink">
	                                    <img src="../assets/images/webLogo_date190621.png">
	                                </a>
	                            </div>
	                        </div> -->
						</section>

	                </div>
	            </article>


	        </div>
	    </div>
	    <loading v-if="loadingShow === true"></loading>

	</div>

</template>

<script>
import $ from 'jquery';
import moment from 'moment';
import axios from 'axios';
import Loading from '../components/loading.vue';
export default {
  name: 'BookingView',
  components: {
  	Loading,
  },

  data() {
	return {
		storeLogo:'',
        storeName:'',
        storePhone:'',
        isHidden:true,
		paramsValid: true,
		currentPage: 0,
		week: 'Wednesday',
		currentSize: '5',
		currentDate: '10 Jun 2020',
		currentTime: '08:30',
		infoForm: {
			firstName: 'Eric',
			surname: 'Guo',
			areaCode:'+44',
			phone: '12345678901',
			email: 'BBBddd@AAa.org',
		},
		read: true,
	    selectedDate:'',
	    store_id :0,
	    showCancelAlert:false,
	    cancelConfirmed:false,
	    res_id:0,
	    loadingShow:true
	}


  },
  computed: {


  },
  created() {
    var reserve_number=this.$route.params.reserve_number;
    this.res_id=reserve_number;
    this.getReserveData(reserve_number);
  },

  methods: {
        getStoreData(store_id){
          axios.get(process.env.API_URL+'htmlReserve/getStoreData',{params:{store_id:store_id}}).then(res=>{
            console.log(res);
            this.store_id=res.data.data.store_id;
            this.storeName =res.data.data.store_name;
            this.storePhone=res.data.data.contact_phone;
            this.storeLogo = res.data.data.logo;
          })
        },
    getReserveData(res_id){
      axios.get(process.env.API_URL+'htmlReserve/getReserveData',{params:{reserve_id:res_id}}).then(res=>{
        if(res.data.data.status==4){
            this.cancelConfirmed=true;
            this.isHidden = false ;
        }
        this.getStoreData(res.data.data.store_id);
        this.infoForm.firstName=res.data.data.cust_first_name;
        this.infoForm.surname=res.data.data.cust_surname;
        this.currentDate=res.data.data.date;
        this.week=res.data.data.wekday;
        this.currentTime=res.data.data.r_time;
        this.currentSize=res.data.data.covers;
        this.infoForm.phone=res.data.data.cust_phone;
        this.infoForm.email=res.data.data.cust_email;
        if(res.data.data.slogo !=1){
          this.storeLogo=res.data.data.slogo;
        }
        this.loadingShow=false;
      })
    },
    confirmReserve(res_id){
      this.loadingShow=true;
      axios.post(process.env.API_URL+'htmlReserve/confirmReserve',{params:{res_id:res_id,flag:1}}).then(res=>{
      this.isHidden=false;
      this.loadingShow=false;
      })
    },
    cancelConfirm(res_id){
      this.loadingShow=true;
      axios.post(process.env.API_URL+'htmlReserve/confirmReserve',{params:{res_id:res_id,flag:2}}).then(res=>{
        this.cancelConfirmed=true;
        this.loadingShow=false;
      })
    }


  },
  mounted() {
  }
}

</script>
<style scoped="scoped">
#reservation article.swiper-container{ top: calc(126px - 45px)}
#reservation nav.detail-nav{ background: #f9f9f9; box-shadow: 0 2px 5px rgba(5,5,5,.08);}
#reservation #page-1{ padding-top: 20px;}
#reservation #confirmedTips{ text-align: center;/* margin-bottom: 300px;*/}
#reservation #confirmedTips ul {background: rgba(238,238,252,1);}
#reservation #confirmedTips li{ width: 100%; text-align: center;}
#reservation .buttons-col { padding: 10px 26px; position: relative;}
#reservation .buttons-col button{ position: relative; width: calc(100%); display: block; margin-bottom: 20px; font-size: 16px; padding:15px 0; border-radius: 8px; box-shadow: 5px 5px 10px rgba(5,5,5,.2), -3px -3px 3px rgba(6,6,6,.05); font-weight: 700;}
#reservation .buttons-col button.confirmStyle {background: linear-gradient(135deg, #6e8efb, #a777e3); background: #6e8efb; color: #fff;border: none}
#reservation .buttons-col button.cancelStyle{background: rgb(238,238,252); border:2px solid #6e8efb;
background: radial-gradient(circle, rgba(238,238,252,1) 55%, rgba(205,205,205,.6) 100%);background: rgba(238,238,252,1);}
#reservation .buttons-col button.confirmStyle:hover,
#reservation .buttons-col button.confirmStyle:active{background: linear-gradient(135deg, #a777e3, #6e8efb); background: #a777e3; }
#reservation .buttons-col button.cancelStyle:hover,
#reservation .buttons-col button.cancelStyle:active{ background: #fff;}
#reservation .cancelStyleTips{ padding: 0 20px;}
#reservation .cancelStyleTips .alertBody{background:rgba(238,238,252,1); padding: 20px;}
#reservation .cancelStyleTips .alertBody .titleCol{ color: #333; font-size: 16px; font-weight: 600;}
#html-loading{ top:0; width:100%; height: 100%;}
#html-loading .sk-circle { top: 40%;}
.pace-done #html-loading{ display: block;}

@media screen and (min-width: 640px) {
	#reservation .buttons-col button{}
	#reservation article.swiper-container{padding-top: calc(50px + 31px); top:0}
	#reservation .buttons-col button{ width: 300px; margin: 0 auto 20px;}
}

</style>



// WEBPACK FOOTER //
// src/page/BookingView.vue